// import { accountSessionActions } from 'store/actions';
import { CUSTOMERSDETAILS } from '../actionTypes';

const initialState = {
  cardDetails: [],
  customerDetailsStatus: undefined,
  customerDetailsError: undefined,
  paymentDetails: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMERSDETAILS.FETCH:
      return {
        ...state,
        customerDetailsStatus: 'STARTED',
      };
    case CUSTOMERSDETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        customerDetailsStatus: 'SUCCESS',
      };
    case CUSTOMERSDETAILS.FAILED:
      return {
        ...state,
        customerDetailsError: action.payload,
        customerDetailsStatus: 'FAILED',
      };
    case CUSTOMERSDETAILS.CARDS_SUCCESS:
      return {
        ...state,
        cardDetails: action.payload,
      };
    case CUSTOMERSDETAILS.PAYMENTS_SUCCESS:
      return {
        ...state,
        paymentDetails: action.payload,
      };
    default:
      return state;
  }
};
